import React ,{useRef}from 'react';
import apps from "../../../asset/img/apps.svg";
import {Component} from "react/lib/ReactBaseClasses";
import portLogo from "../../../asset/img/port_icon.png";
import masrafLogo from "../../../asset/img/masraf_icon.png";
import puantajLogo from "../../../asset/img/puantaj_icon.png";
import dakikaLogo from "../../../asset/img/dakika-icon.png";
import InfoTooltip from '../../common/tooltip/info';
import { withNamespaces } from 'react-i18next';


class ModulesMenu extends Component {
    constructor(props) {
        super(props);
    }

    render = () => {

        const modulesLogo = {
            port: portLogo,
            masraf: masrafLogo,
            puantaj: puantajLogo,
        };
        const {isModuleMenuOpen, handelClick, t} = this.props;
        const authorities = this.props.authorities || [];
        return (
            <div>
                <InfoTooltip info={t('moduleTooltip')} placement="bottom">
                    <button type="button" className="apps-button" 
                        onClick={() => handelClick('modules')}>
                        <img src={apps} className="apps-icon"/>
                    </button>
                </InfoTooltip>

                {isModuleMenuOpen ?  (
                    <div className="apps-button-menu" ref={node => this.node = node}>

                        <a href={"https://app.dakika.com.tr/payroll/"}  target="_blank">
                                     <span className="apps-menu-item">
                                      <img src={dakikaLogo} alt="logo" style={{height:"20px", paddingRight:"10px"}}/>
                                      <span >{"Dakika"}</span>
                                      <hr/>
                                    </span>
                        </a>
                        {authorities.map(a =>
                                (  <a href={a.redirect}  key={a.title} target="_blank">
                                     <span className="apps-menu-item">
                                      <img src={modulesLogo[a.logo]} alt="logo" style={{height:"20px", paddingRight:"10px"}}/>
                                      <span >{a.title}</span>
                                      <hr/>
                                    </span>
                                    </a>
                                )
                        )}
                    </div>) :null}

            </div>
        );
    };
}

export default withNamespaces()(ModulesMenu);



// WEBPACK FOOTER //
// ./src/components/header/modules-menu/index.js